import { useEffect, ReactNode } from "react";
import { useAuth } from "../Auth/AuthProvider";
import i18n from "../i18n";
import { getLangFromCountry } from "../utils/langUtils";

interface I18nLanguageInitializerProps {
  children: ReactNode;
}

const I18nLanguageInitializer = ({ children }: I18nLanguageInitializerProps) => {

    const { user, isAuthenticated } = useAuth();
    useEffect(() => {

        if (!isAuthenticated  || !user ) {
            return;
        }
        const storedLang = localStorage.getItem("userLang");

        const countryKey  = user?.countryKey;
        const langKey = storedLang || getLangFromCountry(countryKey);
        i18n?.changeLanguage(langKey);
        }, [user, isAuthenticated]);

    return <>{children}</>;
};

export default I18nLanguageInitializer;